import React, { useContext } from 'react'
import _ from 'lodash'

import Helmet from 'react-helmet'
import { StaticQuery, graphql } from 'gatsby'
import uniqid from 'uniqid'

import { OverlayContext } from './OverlayContext'
import './seo.css'

type Props = {
  lang?: string
  dataBrand?: string
  dataTheme?: string
  meta?: []
  keywords?: string[]
  title: string
  type: string
  noIndex?: boolean
  description: string
}
const detailsQuery = graphql`
  query DefaultSEOQuery {
    site {
      siteMetadata {
        description
      }
    }
  }
`
const MarketoForm = () => {
  const { updateMarketo } = useContext(OverlayContext)
  const scriptSrc = '/forms2.min.js'
  const MUNCHKIN_ID = process.env.SF_MARKETO_MUNCHKIN_ID
  if (!MUNCHKIN_ID) {
    return null
  }

  const handleChangeClientState = (newState, addedTags) => {
    if (addedTags?.scriptTags) {
      const foundScript = addedTags.scriptTags.find(({ src }) =>
        src.includes(scriptSrc)
      )
      if (foundScript) {
        foundScript.addEventListener('load', () => updateMarketo(true), {
          once: true
        })
      }
    }
  }
  return (
    <Helmet onChangeClientState={handleChangeClientState}>
      {typeof window !== 'undefined' && (
        <script async defer src="/forms2.min.js" type="text/javascript" />
      )}
    </Helmet>
  )
}

export default ({
  lang = 'en-US',
  dataBrand = 'sustainable-fitch',
  dataTheme="light",
  meta = [],
  keywords = [],
  noIndex = false,
  title,
  description,
  type,
  ...props
}: Props) => {
  return (
    <>
      <StaticQuery
        query={detailsQuery}
        render={() => {
          const ogType = type.replace('Contentful', '')
          const ogURL = _.get(props, 'openGraphTags.url', '')

          return [
            <Helmet
              key={Math.floor(Math.random() * 100) + 1}
              htmlAttributes={{
                lang,
                "data-brand":dataBrand,
                "data-theme":dataTheme
              }}
              title={title}
              meta={[
                {
                  name: `title`,
                  content: title
                },
                {
                  name: `description`,
                  content: description
                },
                {
                  property: `og:description`,
                  content: description
                },
                {
                  property: `og:image`,
                  content: '/images/sustainable-fitch-share.jpg'
                },
                {
                  property: `og:url`,
                  content: `/${ogURL}`
                },
                {
                  property: `og:title`,
                  content: title
                },
                {
                  property: `og:type`,
                  content: ogType
                },
                {
                  property: `og:site_name`,
                  content: 'Sustainable Fitch'
                }
              ]
                .concat(
                  noIndex
                    ? {
                        name: `robots`,
                        content: 'noindex,nofollow,noodp'
                      }
                    : []
                )
                .concat(
                  noIndex
                    ? {
                        name: `googlebot`,
                        content: 'noindex,nofollow,noodp'
                      }
                    : []
                )
                .concat(
                  keywords.length > 0
                    ? {
                        name: `keywords`,
                        content: keywords.join(`, `)
                      }
                    : []
                )
                .concat(meta)}
            />,
            <MarketoForm key={uniqid()} />
          ]
        }}
      />
    </>
  )
}
